var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"documentation"},[_c('TheHeader',{ref:"header"}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('router-view')],1),_vm._v(" "),_c('TheFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29478062","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DefaultTemplate.vue
// module id = 187
// module chunks = 20